import { isStringBlankOrNull, stringToNumberOrNull } from '@/Utils/stringUtil';

/**
 * Prepares the registration call priority override for sending to the backend.
 *
 * @param operator The operator object containing registrationCallPriorityOverride
 * @returns The registrationCallPriorityOverride as a `number` if it was a `string`, otherwise
 * returns the original value. Returns `null` if the string was blank.
 */
export const prepareRegistrationCallPriorityOverride = (operator: {
  registrationCallPriorityOverride: string | number | null;
}): number | null => {
  const override = operator.registrationCallPriorityOverride;
  if (typeof override === 'number') return override;
  if (isStringBlankOrNull(override)) return null;
  return stringToNumberOrNull(override);
};

/**
 * Converts the registration call priority override property on an operator object into a
 * displayable string.
 *
 * @param operator The operator object containing registrationCallPriorityOverride
 */
export const displayRegistrationCallPriorityOverride = (operator: { registrationCallPriorityOverride: string | number | null }): string => {
  return prepareRegistrationCallPriorityOverride(operator)?.toString() ?? '-';
};

type RegistrationCallPriorityRow = {
  registrationCallType?: string | null;
  priority?: number | null;
};

/**
 * Renders registration call priorities for list display (one type per line).
 */
export const displayRegistrationCallPriorities = (priorities: RegistrationCallPriorityRow[] | null | undefined): string => {
  if (!priorities?.length) return '-';
  return priorities.map((p) => `${p.registrationCallType ?? ''}: ${p.priority ?? ''}`).join('\n');
};

const registrationCallPriorityOverride = {
  displayFrom: displayRegistrationCallPriorityOverride,
  prepareFrom: prepareRegistrationCallPriorityOverride,
};

export default registrationCallPriorityOverride;
